import { createTheme } from "@material-ui/core/styles";

export const heTheme = createTheme({
  direction: "rtl",
});

export const enTheme = createTheme({
  direction: "ltr",
});
